import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionSecurityService } from '@shared/services';
import { MsalService } from '@azure/msal-angular';
import { Observable } from 'rxjs';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(
        private authService: MsalService,
        private sessionSecurity: SessionSecurityService
        ) { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (request.headers.has('Anonymous')) {

            // Remove the Anonymous Header. 
            // This used to skip the Authorization token
            request = request.clone({
                headers: request.headers.delete('Anonymous')
            });
        }
        else {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${this.sessionSecurity.getObject('iBGCA.idtoken')}`
                }
            });
        }
        return next.handle(request);
    }
}